module.exports = __webpack_public_path__ + "img/power.c4a0e0fb.png";